import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Withdrawals from './components/Withdrawals';
import Integrations from './components/Integrations';
import NavBar from './components/NavBar';
import { verifyAuth } from './services/api';
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      verifyAuth()
        .then((data) => setUser(data?.user))
        .catch(() => localStorage.removeItem('token'));
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <NavBar user={user} />
        <Routes>
          <Route path="/" element={<Dashboard user={user} />} />
          <Route path="/withdrawals" element={<Withdrawals user={user} />} />
          <Route path="/integrations" element={<Integrations user={user} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
